import { AccountsReceivable } from "./ShipperAccountsReceivable";
import { ContactInformation } from "./ShipperContactInformation";
import { Employee } from "./ShipperEmployees";
import { Insurance } from "./ShipperInsurance";
import { UserType } from "./User";

export enum ShipperType {
  Shipper = "SHIPPER",
  Broker = "BROKER",
}

export type ShipperOrBroker = Exclude<UserType, UserType.CARRIER>;

export interface ShipperAccountRequestData {
  // ContactInformation
  companyName: string;
  adminFirst: string;
  adminLast: string;
  adminEmail: string;
  companyEmail: string;
  companyWebsite: string;
  companyPhone: string;
  dunsCode: string;
  naicsCode: string;
  // Insurance
  insurance: {
    autoLiability: string;
    generalLiability: string;
    cargoInsurance: string;
  };
  // AccountsReceivable + Address
  accountsReceivable: AccountsReceivable;
  userType: ShipperOrBroker;
}
export interface ShipperUserData {
  contactInformation: ContactInformation;
  employees: Employee[];
  accountsReceivable: AccountsReceivable;
  insuranceRequirements: Insurance;
}

export interface ShipperUser extends ShipperUserData {
  id: string;
  shipperCode: string;
  status: ShipperStatus;
  userType: ShipperType;
  tilledId: string;
  createDate?: Date;
}

export enum ShipperStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  REVOKED = "REVOKED",
}

export enum ShipperStatusLabel {
  PENDING = "Pending",
  APPROVED = "Active",
  REJECTED = "Rejected",
  REVOKED = "Inactive",
}
